import './AgentAuditOperationDetail.css';

interface ToolCall {
  name?: string;
  args?: Record<string, unknown>;
  id?: string;
  type?: string;
  result?: unknown;
  status?: string;
}

interface UsedToolsProps {
  tools?: ToolCall[];
}

function ToolArguments({ toolArguments }: { toolArguments?: Record<string, unknown> }) {
  const argumentEntries = Object.entries(toolArguments || {});

  if (argumentEntries.length === 0) {
    return <div className="used-tool-empty">No arguments</div>;
  }

  return (
    <div className="tool-block">
      <div className="input-title tool-block-title">Arguments</div>
      <div className="tool-args-list">
        {argumentEntries.map(([argumentName, argumentValue]) => {
          const isStructuredValue = typeof argumentValue === 'object' && argumentValue !== null;

          return (
            <div className="tool-arg-row" key={argumentName}>
              <div className="tool-arg-name">{argumentName}</div>
              {isStructuredValue ? (
                <pre className="tool-pre">{JSON.stringify(argumentValue, null, 2)}</pre>
              ) : (
                <div className="used-tool-argument-value">{String(argumentValue ?? 'null')}</div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

function ToolResult({ result }: { result: unknown }) {
  if (result === undefined) return null;

  const formattedResult = typeof result === 'string' ? result : JSON.stringify(result, null, 2);

  return (
    <div className="tool-block">
      <div className="input-title tool-block-title">Result</div>
      <pre className="tool-pre">{formattedResult}</pre>
    </div>
  );
}

function UsedTools({ tools }: UsedToolsProps) {
  const toolCalls = Array.isArray(tools) ? tools : [];

  return (
    <div className="radius-yes p-2 bg-yes col-12">
      <h2 className="h5-title">Tools Used</h2>
      {toolCalls.length === 0 ? (
        <div className="used-tool-empty">No tools were used for this request.</div>
      ) : (
        <div className="available-tools-list">
          {toolCalls.map((tool, toolIndex) => {
            const toolName = tool.name || `Tool ${toolIndex + 1}`;

            return (
              <details
                className="available-tool-item"
                key={`${tool.id || toolName}-${toolIndex}`}
                open={toolIndex === 0}
              >
                <summary className="available-tools-summary" style={{ fontWeight: 600 }}>
                  <span className="tool-caret" aria-hidden="true">
                    ▶
                  </span>
                  <span>{toolName}</span>
                </summary>

                <div className="available-tool-body">
                  {tool.id && (
                    <div className="tool-meta-line">
                      <span style={{ fontWeight: 600 }}>Call ID:</span> {tool.id}
                    </div>
                  )}
                  {tool.type && (
                    <div className="tool-meta-line">
                      <span style={{ fontWeight: 600 }}>Type:</span> {tool.type}
                    </div>
                  )}
                  {tool.status && (
                    <div className="tool-meta-line">
                      <span style={{ fontWeight: 600 }}>Status:</span> {tool.status}
                    </div>
                  )}
                  <ToolArguments toolArguments={tool.args} />
                  <ToolResult result={tool.result} />
                </div>
              </details>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default UsedTools;
